export default {
  pending: "pending",
  authorized: "authorized",
  unauthorized: "unauthorized",
};
